module.exports = __webpack_public_path__ + "img/bulb_image.31e62ffa.svg";